<div #container class="ocl-container-with-padding" >
  <div #controls style="margin-bottom: 16px">
    <div fxLayout="row" fxLayoutAlign="space-between">
        <app-loading-header [loading]="isLoading">Insurance Information</app-loading-header>
        <div fxLayout="row" fxLayoutAlign="end end">
            <dx-drop-down-button
                style="height: 26px"
                [visible]="isPhone"
                [splitButton]="false"
                [showArrowIcon]="false"
                [dropDownOptions]="{ width: 100 }"
                icon="overflow"
                [items]="responsiveButtons"
                displayExpr="name"
                keyExpr="id"
                (onItemClick)="onItemClick($event)">
            </dx-drop-down-button>
        </div>
    </div>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between">
      <div class="dx-field">
        <div class="dx-field-label">Bill Type</div>
        <div class="dx-field-value">
          <dx-select-box [dataSource]="billTypesDataSource.value"
                         [displayExpr]="'name'"
                         (onValueChanged)="billTypeChanged($event)"
                         [searchEnabled]="true"
                         [(value)]="selectedBillType"
                         [dropDownOptions]="{
                            minWidth: '400px'
                         }"
          ></dx-select-box>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">Payer</div>
        <div class="dx-field-value">
            <dx-drop-down-box
                #payerDropDown
                [(value)]="selectedPayer"
                [deferRendering]="true"
                [displayExpr]="'name'"
                placeholder="Select..."
                [dataSource]="payersDataSource.value"
                [dropDownOptions]="{
                            minWidth: '400px'
                         }"
            >

                <div *dxTemplate="let data of 'content'">
                    <dx-data-grid
                        [dataSource]="payersDataSource.value"
                        [columns]="['name']"
                        [selection]="{ mode: 'single' }"
                        [hoverStateEnabled]="true"
                        [paging]="{ enabled: true, pageSize: 10 }"
                        [scrolling]="{ mode: 'infinite' }"
                        (onSelectionChanged)="payerChanged($event)"
                        [height]="gridHeight"
                    >
                        <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
                        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                        <dxo-remote-operations [paging]="true" [filtering]="true"></dxo-remote-operations>
                    </dx-data-grid>
                </div>
            </dx-drop-down-box>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">Insurance Id</div>
        <div class="dx-field-value">
          <dx-text-box
            class="uppercase"
            [(value)]="insuranceId"
            (onValueChanged)="changeStateButtons()"
          ></dx-text-box>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">Group Number</div>
        <div class="dx-field-value">
          <dx-text-box
            class="uppercase"
            [(value)]="groupNumber"
            (onValueChanged)="changeStateButtons()"
          ></dx-text-box>
        </div>
      </div>
      <div class="button-group" *ngIf="!isPhone">
        <dx-tooltip target="#addBtn" showEvent="dxhoverstart" hideEvent="dxhoverend">
          <div *dxTemplate="let data of 'content'">
            <p>Add</p>
          </div>
        </dx-tooltip>
        <dx-tooltip target="#removeBtn" showEvent="dxhoverstart" hideEvent="dxhoverend">
          <div *dxTemplate="let data of 'content'">
            <p>Remove</p>
          </div>
        </dx-tooltip>
        <dx-tooltip target="#searchBtn" showEvent="dxhoverstart" hideEvent="dxhoverend">
          <div *dxTemplate="let data of 'content'">
            <p>Search</p>
          </div>
        </dx-tooltip>

        <dx-tooltip target="#upBtn" showEvent="dxhoverstart" hideEvent="dxhoverend">
          <div *dxTemplate="let data of 'content'">
            <p>Move Up</p>
          </div>
        </dx-tooltip>
        <dx-tooltip target="#downBtn" showEvent="dxhoverstart" hideEvent="dxhoverend">
          <div *dxTemplate="let data of 'content'">
            <p>Move Down</p>
          </div>
        </dx-tooltip>
        <dx-tooltip target="#saveBtn" showEvent="dxhoverstart" hideEvent="dxhoverend">
          <div *dxTemplate="let data of 'content'">
            <p>Save</p>
          </div>
        </dx-tooltip>
        <dx-button
          id="upBtn"
          [icon]="'arrowup'"
          [disabled]="disableUp"
          title="Up"
          (click)="changeUp()"
          style="height: 24px; margin-top: 27px; margin-right: 4px;"
        ></dx-button>
        <dx-button
          id="downBtn"
          [icon]="'arrowdown'"
          [disabled]="disableDown"
          title="Down"
          (click)="changeDown()"
          style="height: 24px; margin-top: 27px; margin-right: 4px;"
        ></dx-button>
        <dx-button
          id="saveBtn"
          [icon]="'save'"
          [disabled]="selectedRows.length !== 1"
          title="Down"
          (click)="saveBtnClicked()"
          style="height: 24px; margin-top: 27px; margin-right: 4px;"
        ></dx-button>
        <dx-button
          id="addBtn"
          [icon]="'add'"
          [disabled]="insuranceId === '' || selectedPayer === undefined || selectedBillType === undefined"
          (click)="addBtnClicked()"
          title="Add"
          style="height: 24px; margin-top: 27px; margin-right: 4px;margin-left: 4px;"
        ></dx-button>
        <dx-button
          id="removeBtn"
          [icon]="'trash'"
          [disabled]="selectedRows.length === 0"
          (click)="removeBtnClicked()"
          title="Remove"
          style="height: 24px; margin-top: 27px; margin-right: 4px;"
        ></dx-button>
      </div>
    </div>
  </div>

  <dx-data-grid
    [height]="gridHeight"
    [(dataSource)]="patientBillingInformation"
    [showBorders]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [allowColumnResizing]="true"
    (selectedRowKeysChange)="selectionChange($event)"
    [(focusedRowIndex)]="selectedRowIndex"
    [(selectedRowKeys)]="selectedRows"
    [columnHidingEnabled]="isPhoneOrTablet"
  >
    <dxi-column dataField="billType" caption="Bill Type" [hidingPriority]="isPhoneOrTablet ? 4 : null"></dxi-column>
    <dxi-column dataField="payer" caption="Payer" [hidingPriority]="isPhoneOrTablet ? 3 : null"></dxi-column>
    <dxi-column dataField="insuranceId" caption="Insurance Id" [hidingPriority]="isPhoneOrTablet ? 2 : null"></dxi-column>
    <dxi-column dataField="groupNumber" caption="Group Number" [hidingPriority]="isPhoneOrTablet ? 2 : null"></dxi-column>
    <dxi-column dataField="order" caption="Order" alignment="center" [hidingPriority]="isPhoneOrTablet ? 1 : null"></dxi-column>
    <dxi-column
      caption=""
      [width]="110"
      [allowFiltering]="false"
      [allowSorting]="false"
      cellTemplate="editingTemplate"
      [hidingPriority]="isPhoneOrTablet ? 0 : null"
    ></dxi-column>

    <div *dxTemplate="let cellInfo of 'editingTemplate'">
      <div fxLayout="row" fxLayoutAlign="start center" style="width: 110px">
            <dx-button
                icon="edit"
                text="Edit"
                style="margin-right: 3px; width: 80px"
                (onClick)="editBtnClicked(cellInfo)"
            ></dx-button>
            <i *ngIf="verifyMissingInformation(cellInfo)" class="dx-icon-warning" style="font-size: 14px; color: #ff9d09" title="It has missing information"></i>
      </div>
    </div>

    <dxo-scrolling [showScrollbar]="'always'" [mode]="'virtual'"></dxo-scrolling>
    <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>
  </dx-data-grid>

  <app-edit-billing-information
      (reloadPatientEvent)="reloadPatientData($event)"
      (closeEvent)="closeDialog($event)"
      [patientBillingInformation]="editingRowInfo ? editingRowInfo.data : null"
      [popupVisible]="isEditVisible"
      [patient]="patient"></app-edit-billing-information>
</div>
